import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { ALLOWED_ADMINS } from '../lib/admin';

export default function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const [loading, setLoading] = useState(true);
  const [isAuthorized, setIsAuthorized] = useState(false);
  const location = useLocation();

  useEffect(() => {
    let unsubscribe: (() => void) | undefined;
    let isMounted = true;

    const initAuth = async () => {
      try {
        const { auth } = await import('../lib/firebase');
        const { onAuthStateChanged } = await import('firebase/auth');
        
        if (!isMounted) return;

        unsubscribe = onAuthStateChanged(auth, (user) => {
          if (!isMounted) return;
          if (!user) {
            setIsAuthorized(false);
          } else {
            const isAdminPath = location.pathname.startsWith('/admin');
            if (isAdminPath) {
              setIsAuthorized(!!user.email && ALLOWED_ADMINS.includes(user.email));
            } else {
              setIsAuthorized(true); // Any logged in user can access non-admin protected routes (like /dashboard)
            }
          }
          setLoading(false);
        });
      } catch (err) {
        console.error('Failed to lazily load auth in ProtectedRoute:', err);
        if (isMounted) setLoading(false);
      }
    };

    initAuth();

    return () => {
      isMounted = false;
      if (unsubscribe) unsubscribe();
    };
  }, [location.pathname]);

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center bg-slate-50">جاري التحقق من الصلاحيات...</div>;
  }

  if (!isAuthorized) {
    const isAdminPath = location.pathname.startsWith('/admin');
    return <Navigate to={isAdminPath ? "/admin/login" : "/login"} state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
